import React from 'react';
import { FaSitemap, FaFileAlt } from 'react-icons/fa';
import ActionButton from '../shared/ActionButton';
import styles from '../styles/DocumentBanner.module.css';

const ICONS = {
  'FaSitemap': <FaSitemap />,
  'FaFileAlt': <FaFileAlt />
};

/**
 * Banner de Documento - Muestra icono, título y descripción
 * @param {string} icon - Nombre del icono (ej: 'FaSitemap')
 * @param {string} badge - Badge superior
 * @param {string} title - Título principal
 * @param {string} description - Descripción
 * @param {Object} action - { type, label, handler, subtitle }
 */
const DocumentBanner = ({ icon, badge, title, description, action }) => {
  const IconComponent = ICONS[icon];

  const handleAction = () => {
    const { type, handler } = action;

    switch (type) {
      case 'pdf':
        window.open(handler, '_blank');
        break;

      case 'external_link':
        window.open(handler, '_blank');
        break;

      case 'api_document':
        // Handler específico para documentos que vienen del API
        if (handler === 'fetch_active_policy') {
          fetchActivePolicy();
        }
        break;

      default:
        if (typeof handler === 'function') {
          handler();
        }
        break;
    }
  };

  const fetchActivePolicy = () => {
    const token = localStorage.getItem('token');
    const API_URL = process.env.NODE_ENV === 'development' 
      ? 'http://localhost:4005' 
      : '';
    
    fetch(`${API_URL}/api/politicas/version-activa`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        if (data.success && data.data) {
          const url = `${API_URL}/api/politicas/documento/${data.data.id}?token=${token}`;
          window.open(url, '_blank');
        } else {
          alert('No hay política disponible en este momento');
        }
      })
      .catch(err => {
        console.error('Error al abrir política:', err);
        alert('Error al abrir el documento');
      });
  };

  return (
    <div className={styles.documentBanner}>
      <div className={styles.content}>
        <div className={styles.iconSection}>
          {IconComponent && (
            <div className={styles.iconWrapper}>
              {IconComponent}
            </div>
          )}
        </div>

        <div className={styles.textSection}>
          <span className={styles.badge}>{badge}</span>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.description}>{description}</p>
        </div>

        <ActionButton
          onClick={handleAction}
          icon={action.icon}
          subtitle={action.subtitle}
          variant="secondary"
          className={styles.actionButton}
        >
          {action.label}
        </ActionButton>
      </div>
    </div>
  );
};

export default DocumentBanner;
